import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-monthly-report"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row pb-0" }
const _hoisted_4 = { style: {"width":"20%","float":"left"} }
const _hoisted_5 = {
  class: "ml-4",
  style: {"font-weight":"bold"}
}
const _hoisted_6 = {
  class: "ml-4 mt-1",
  style: {"font-weight":"bold"}
}
const _hoisted_7 = { style: {"width":"60%","float":"left"} }
const _hoisted_8 = {
  class: "text-center no-margin",
  style: {"font-weight":"bold"}
}
const _hoisted_9 = {
  class: "text-center mt-1",
  style: {"font-weight":"bold"}
}
const _hoisted_10 = { class: "row pt-0 pb-0" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = {
  class: "ml-5 mb-0 mt-0",
  style: {"font-weight":"bold","font-size":"13px"}
}
const _hoisted_13 = { class: "mt-0 pb-0 d-flex justify-content-end mr-3" }
const _hoisted_14 = { class: "list-inline-item" }
const _hoisted_15 = { class: "no-margin no-padding" }
const _hoisted_16 = { class: "list-inline-item" }
const _hoisted_17 = { class: "list-inline-item" }
const _hoisted_18 = { class: "list-inline-item" }
const _hoisted_19 = { class: "d-flex justify-content-end" }

import { ref, reactive, onMounted } from "vue";
import { useRoute } from "vue-router";
import Api from "@/services/api/ApiServiceFabrick";
import { useAuth } from "@/services/user/Auth0UserProvider";
import outputContentsMonthlyData from "@/types/apiresponses/jobStatusOutputContentsMonthlyData";
import SummaryTimesTable from "@/components/MonthlyReportWorkingTimesSettingParts/SummaryTimesTable.vue";
import DetailTable from "@/components/MonthlyReportWorkingTimesSettingParts/DetailTable.vue";
import {
  convertSecondsFromStringTime,
  formatTimeFromSeconds,
} from "@/services/functions";
import AuthorityCacheApi from "@/services/models/AuthorityCacheApi";
import i18n from '@/lang/i18n';

type monthlySummaryData = {
  restraintTime?: string;
  workingTime?: string;
  mileage?: number;
  drivingTime?: string;
  breakTime?: string;
  loadingTime?: string;
  unloadingTime?: string;
  shippingTime?: string;
  waitTime?: string;
  othersTime?: string;
  restTime?: string;
  leavingDiffTime?: string;
  overTime?: string;
  midnightWorkingTime?: string;
  boundTimeByDays?: string;
  average?: string;
  boundTimeByHours?: string;
  workingDays?: number;
};
type alertSetting = {
  alertLv1Time?: string;
  alertLv2Time?: string;
  alertLv3Time?: string;
  alertLv1Color?: string;
  alertLv2Color?: string;
  alertLv3Color?: string;
};
const monthlyReportPath = "/monthly-report";

export default /*@__PURE__*/_defineComponent({
  __name: 'MonthlyReportWorkingTimesSetting',
  props: {
  showFlash: {
    type: Function,
    default: () => null,
  },
},
  setup(__props) {

const props = __props;
const { loginWithRedirect } = useAuth();
const loading = ref<boolean>(false);
const monthlyDataRef: any = ref<outputContentsMonthlyData>({});
const route = useRoute();
const monthlySummaryDataRef: any = reactive<monthlySummaryData>({});
const alertSettingRef = reactive<alertSetting>({});
const monthlyDetailDataRef = reactive<Array<any>>([]);
const monthlyTripsRef = reactive<Array<any>>([]);
const maxWorkingTime = reactive<any>({});
const saveBtnClickState = ref<boolean>(false);
const isGotMonthlyData = ref<boolean>(false);
const updateAuthority = ref<boolean>(false);

onMounted(() => {
  getAuthority();
  loadMonthlyData();
});

const getAuthority = async() => {
  const authorityList = await AuthorityCacheApi.getWithParse()
  updateAuthority.value = !!authorityList["octlink.monthly_report.update"]
}

const loadMonthlyData = () => {
  loading.value = true;

  const params = {
    type: "App\\Services\\OutputReports\\Monthly\\Drivers\\Individual\\PreviewCreateService",
    account_id: Number(route.query.account_id),
    operation_office_id: Number(route.query.operation_office_id),
    monthly: route.query.monthly?.toString(),
  };

  Api()
    .createJobStatus(params)
    .then((data) => {
      pollingJobStatus(data.id);
    })
    .catch((error) => {
      const res = error.response;
      switch (res.status) {
        case 401:
          loginWithRedirect({ appState: { targetUrl: location.pathname } });
          break;
        case 403:
          loginWithRedirect({ appState: { targetUrl: monthlyReportPath } });
          break;
        case 422:
      }
      loading.value = false;
    });
};

const pollingJobStatus = (id: number) => {
  const interval = setInterval(() => {
    Api()
      .getJobStatus(id)
      .then((res) => {
        if (isGotMonthlyData.value) {
          clearInterval(interval);
          loading.value = false;
        } else if (res.status == "completed") {
          isGotMonthlyData.value = true;
          monthlyDataRef.value = res.output_contents;

          setSummaryMonthlyData();
          setAlertSetting();
          setDetailedMonthlyData();
          setMonthlyTrips();
          setOverTimeThresholds(monthlyDataRef.value?.monthlyReportSetting);

          clearInterval(interval);
          loading.value = false;
        } else if (res.status == "failed") {
          isGotMonthlyData.value = true;
          let message = res.output_contents?.message ?? "";
          if (res.output_contents?.detail_message) {
            message += "\n\n" + res.output_contents?.detail_message;
            props.showFlash(message, "error", false);
          } else {
            alert(res?.output_contents?.message);
          }
          clearInterval(interval);
          loading.value = false;
        }
      });
  }, 3000);
};

const setOverTimeThresholds = (monthlyReportSetting: any) => {
  if (!monthlyReportSetting) return;

  const settingsMonthlyReport = JSON.parse(monthlyReportSetting);
  const overTimeThresholds = settingsMonthlyReport?.["over_time_thresholds"];
  const month = Number(route.query.monthly?.toString().split("/")[1]);

  if (overTimeThresholds["daily"]) {
    const threshold = overTimeThresholds["daily"];
    const thresholdSeconds = convertSecondsFromStringTime(threshold);

    maxWorkingTime.type = "daily";
    maxWorkingTime.seconds = thresholdSeconds;
  } else {
    const threshold = overTimeThresholds[month];
    if (!threshold) return;

    const thresholdSeconds = convertSecondsFromStringTime(threshold);
    maxWorkingTime.type = "monthly";
    maxWorkingTime.seconds = thresholdSeconds;
  }
};

const setSummaryMonthlyData = () => {
  monthlySummaryDataRef.restraintTime =
    monthlyDataRef.value.monthlyData?.overview?.restraint;
  monthlySummaryDataRef.workingTime =
    monthlyDataRef.value.monthlyData?.overview?.working_time;
  monthlySummaryDataRef.mileage =
    monthlyDataRef.value.monthlyData?.overview?.total_mileage;
  monthlySummaryDataRef.drivingTime =
    monthlyDataRef.value.monthlyData?.overview?.driving;
  monthlySummaryDataRef.breakTime =
    monthlyDataRef.value.monthlyData?.overview?.break;
  monthlySummaryDataRef.loadingTime =
    monthlyDataRef.value.monthlyData?.overview?.loading_time;
  monthlySummaryDataRef.unloadingTime =
    monthlyDataRef.value.monthlyData?.overview?.unloading_time;
  monthlySummaryDataRef.shippingTime =
    monthlyDataRef.value.monthlyData?.overview?.shipping_time;
  monthlySummaryDataRef.waitTime =
    monthlyDataRef.value.monthlyData?.overview?.wait_time;
  monthlySummaryDataRef.othersTime =
    monthlyDataRef.value.monthlyData?.overview?.others_time;
  monthlySummaryDataRef.restTime =
    monthlyDataRef.value.monthlyData?.overview?.rest;
  monthlySummaryDataRef.leavingDiffTime =
    monthlyDataRef.value.monthlyData?.overview?.leaving_diff_time;
  monthlySummaryDataRef.overTime =
    monthlyDataRef.value.monthlyData?.overview?.over_time;
  monthlySummaryDataRef.midnightWorkingTime =
    monthlyDataRef.value.monthlyData?.overview?.over_night_time;
  monthlySummaryDataRef.boundTimeByDays =
    monthlyDataRef.value.colorSetting?.bound_time_by_days ?? "0";
  monthlySummaryDataRef.average =
    monthlyDataRef.value.monthlyData?.overview?.average;
  monthlySummaryDataRef.boundTimeByHours =
    monthlyDataRef.value.colorSetting?.bound_time_by_hours ?? "0";
  monthlySummaryDataRef.workingDays =
    monthlyDataRef.value.monthlyData?.overview?.day_exits_data;
};

const setAlertSetting = () => {
  alertSettingRef.alertLv1Time =
    monthlyDataRef.value.colorSetting?.alert_lv1_time;
  alertSettingRef.alertLv2Time =
    monthlyDataRef.value.colorSetting?.alert_lv2_time;
  alertSettingRef.alertLv3Time =
    monthlyDataRef.value.colorSetting?.alert_lv3_time;
  alertSettingRef.alertLv1Color =
    monthlyDataRef.value.colorSetting?.alert_lv1_color;
  alertSettingRef.alertLv2Color =
    monthlyDataRef.value.colorSetting?.alert_lv2_color;
  alertSettingRef.alertLv3Color =
    monthlyDataRef.value.colorSetting?.alert_lv3_color;
};

const setDetailedMonthlyData = () => {
  if (monthlyDetailDataRef.length) return;

  const weeklyAggregation =
    monthlyDataRef.value.monthlyData?.weekly_aggregation ?? {};

  monthlyDataRef.value.monthlyData?.days.forEach((detail) => {
    monthlyDetailDataRef.push({
      day: detail.day,
      trips: detail.trips,
      fullDate: detail.full_date,
      weeklyAggregation: weeklyAggregation[detail.full_date],
      dayOfWeek: detail.day_of_week,
      leavingDiffTime: detail.leaving_diff_time,
    });
  })
};

const setMonthlyTrips = () => {
  monthlyDataRef.value?.trips.forEach((trip: any) => {
    monthlyTripsRef.push(trip);
  });
};

const existColorSetting = () => {
  return (
    !!alertSettingRef.alertLv1Time ||
    !!alertSettingRef.alertLv2Time ||
    !!alertSettingRef.alertLv3Time
  );
};

const updateSummaryTimes = (beforeAfterSecondsTimes: any) => {
  monthlySummaryDataRef.restraintTime = calcAndFormatTime(
    "restraintTime",
    "others_time",
    beforeAfterSecondsTimes
  );
  monthlySummaryDataRef.workingTime = calcAndFormatTime(
    "workingTime",
    "working_time",
    beforeAfterSecondsTimes
  );
  monthlySummaryDataRef.othersTime = calcAndFormatTime(
    "othersTime",
    "others_time",
    beforeAfterSecondsTimes
  );
  monthlySummaryDataRef.leavingDiffTime = calcAndFormatTime(
    "leavingDiffTime",
    "leaving_diff_time",
    beforeAfterSecondsTimes
  );
  monthlySummaryDataRef.overTime = calcAndFormatTime(
    "overTime",
    "over_time",
    beforeAfterSecondsTimes
  );
  monthlySummaryDataRef.midnightWorkingTime = calcAndFormatTime(
    "midnightWorkingTime",
    "over_night_time",
    beforeAfterSecondsTimes
  );

  const workingDays = monthlySummaryDataRef.workingDays;
  if (workingDays && beforeAfterSecondsTimes.restraint) {
    monthlySummaryDataRef.average = formatTimeFromSeconds(
      convertSecondsFromStringTime(monthlySummaryDataRef.restraintTime) /
        workingDays
    );
  }
};

const calcAndFormatTime = (
  refKey: string,
  timesKey: string,
  beforeAfterSecondsTimes: any
) => {
  if (!monthlySummaryDataRef[refKey]) return;
  if (!Object.keys(beforeAfterSecondsTimes[timesKey]).length)
    return monthlySummaryDataRef[refKey];

  const calcTimeSeconds =
    convertSecondsFromStringTime(monthlySummaryDataRef[refKey]) -
    beforeAfterSecondsTimes[timesKey].before +
    beforeAfterSecondsTimes[timesKey].after;
  return formatTimeFromSeconds(calcTimeSeconds);
};

const submit = (workingTimesWithValidation: any) => {
  if (!workingTimesWithValidation.valid) {
    alert(i18n.global.t('pages.monthlyReportWorkingTimesSetting.errors.input'));
    saveBtnClickState.value = false;
    return;
  }

  Api()
    .createOrUpdateDeliveryPlanWorkingTimes(
      workingTimesWithValidation.workingTimes,
      route.query.operation_office_id?.toString() ?? ""
    )
    .then((res) => {
      if (window.confirm(i18n.global.t('pages.monthlyReportWorkingTimesSetting.messages.successSave')))
        window.close();
    })
    .catch((error) => {
      const res = error.response;
      switch (res.status) {
        case 401:
          loginWithRedirect({ appState: { targetUrl: location.pathname } });
          break;
        case 403:
          loginWithRedirect({ appState: { targetUrl: monthlyReportPath } });
          break;
        case 422:
          if (window.confirm(i18n.global.t('pages.monthlyReportWorkingTimesSetting.errors.updateData')))
            location.reload();
      }
    })
    .finally(() => {
      saveBtnClickState.value = false;
    });
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.common.list.reading')), 1)
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, _toDisplayString(monthlyDataRef.value.monthlyData?.info?.operation_name), 1),
          _createElementVNode("h4", _hoisted_6, _toDisplayString(monthlyDataRef.value.monthlyData?.info?.department), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h2", _hoisted_8, _toDisplayString(`${_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.title')} ${ monthlyDataRef.value.monthlyData?.info?.driver }`), 1),
          _createElementVNode("h4", _hoisted_9, _toDisplayString(monthlyDataRef.value.monthlyData?.info?.title_date_range), 1)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.list.monthlyWorkTotal')), 1)
          ])
        ]),
        _createVNode(SummaryTimesTable, {
          detailDataRef: monthlyDetailDataRef,
          restraintTime: monthlySummaryDataRef.restraintTime,
          workingTime: monthlySummaryDataRef.workingTime,
          mileage: monthlySummaryDataRef.mileage,
          drivingTime: monthlySummaryDataRef.drivingTime,
          breakTime: monthlySummaryDataRef.breakTime,
          loadingTime: monthlySummaryDataRef.loadingTime,
          unloadingTime: monthlySummaryDataRef.loadingTime,
          shippingTime: monthlySummaryDataRef.shippingTime,
          waitTime: monthlySummaryDataRef.waitTime,
          othersTime: monthlySummaryDataRef.othersTime,
          restTime: monthlySummaryDataRef.restTime,
          leavingDiffTime: monthlySummaryDataRef.leavingDiffTime,
          overTime: monthlySummaryDataRef.overTime,
          midnightWorkingTime: monthlySummaryDataRef.midnightWorkingTime,
          boundTimeByDays: monthlySummaryDataRef.boundTimeByDays,
          average: monthlySummaryDataRef.average,
          boundTimeByHours: monthlySummaryDataRef.boundTimeByHours,
          workingDays: monthlySummaryDataRef.workingDays,
          alertSetting: alertSettingRef
        }, null, 8, ["detailDataRef", "restraintTime", "workingTime", "mileage", "drivingTime", "breakTime", "loadingTime", "unloadingTime", "shippingTime", "waitTime", "othersTime", "restTime", "leavingDiffTime", "overTime", "midnightWorkingTime", "boundTimeByDays", "average", "boundTimeByHours", "workingDays", "alertSetting"]),
        _createVNode(DetailTable, {
          detailData: monthlyDetailDataRef,
          alertSetting: alertSettingRef,
          monthlyTrips: monthlyTripsRef,
          maxWorkingTime: maxWorkingTime,
          displayWeeklyAggregation: 
          !!monthlyDataRef.value.monthlyData?.weekly_aggregation
        ,
          trips: monthlyDataRef.value.trips,
          btnState: saveBtnClickState.value,
          onChangeWorkingTime: updateSummaryTimes,
          onClickSave: submit
        }, null, 8, ["detailData", "alertSetting", "monthlyTrips", "maxWorkingTime", "displayWeeklyAggregation", "trips", "btnState"]),
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("div", _hoisted_14, [
            _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.list.alertSetting')), 1)
          ], 512), [
            [_vShow, existColorSetting]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_16, [
            _createElementVNode("p", {
              class: "no-margin no-padding",
              style: _normalizeStyle('color:' + alertSettingRef.alertLv1Color)
            }, " 1: " + _toDisplayString(`${alertSettingRef.alertLv1Time}${_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.list.alertLvTime')}`), 5)
          ], 512), [
            [_vShow, !!alertSettingRef.alertLv1Time]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_17, [
            _createElementVNode("p", {
              class: "no-margin no-padding",
              style: _normalizeStyle('color:' + alertSettingRef.alertLv2Color)
            }, " 2: " + _toDisplayString(`${alertSettingRef.alertLv2Time}${_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.list.alertLvTime')}`), 5)
          ], 512), [
            [_vShow, !!alertSettingRef.alertLv2Time]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", {
              class: "no-margin no-padding",
              style: _normalizeStyle('color:' + alertSettingRef.alertLv3Color)
            }, " 3: " + _toDisplayString(`${alertSettingRef.alertLv3Time}${_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.list.alertLvTime')}`), 5)
          ], 512), [
            [_vShow, !!alertSettingRef.alertLv3Time]
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          (updateAuthority.value)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                class: "ma-2 exec-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (saveBtnClickState.value = !saveBtnClickState.value)),
                loading: saveBtnClickState.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.conservation')), 1)
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, !loading.value]
    ])
  ], 64))
}
}

})